// extracted by mini-css-extract-plugin
module.exports = {"container":"Ks6a_container__2DSN-"};